import { render, staticRenderFns } from "./Trunquee.vue?vue&type=template&id=3addd3ae&"
import script from "./Trunquee.vue?vue&type=script&lang=ts&"
export * from "./Trunquee.vue?vue&type=script&lang=ts&"
import style0 from "./Trunquee.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports